var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96811 8.23438H1.37109V22.894H5.96811V8.23438Z",
    stroke: "#0C7D84",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4023 7.91676C18.2328 7.89557 18.0527 7.88498 17.8727 7.87439C15.2988 7.76847 13.8476 9.29374 13.3392 9.95046C13.2015 10.1305 13.138 10.2365 13.138 10.2365V8.27689H8.74219V22.9365H13.138H13.3392C13.3392 21.443 13.3392 19.9601 13.3392 18.4666C13.3392 17.6616 13.3392 16.8566 13.3392 16.0516C13.3392 15.0559 13.2651 13.9967 13.7629 13.0858C14.1866 12.3231 14.9492 11.9418 15.8072 11.9418C18.3493 11.9418 18.4023 14.2403 18.4023 14.4521C18.4023 14.4627 18.4023 14.4733 18.4023 14.4733V23.0001H22.9993V13.4353C22.9993 10.1623 21.3363 8.23452 18.4023 7.91676Z",
    stroke: "#0C7D84",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66923 6.33847C5.14341 6.33847 6.33848 5.14342 6.33848 3.66924C6.33848 2.19506 5.14341 1 3.66923 1C2.19505 1 1 2.19506 1 3.66924C1 5.14342 2.19505 6.33847 3.66923 6.33847Z",
    stroke: "#0C7D84",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.e2eced6997cfb39020accb33ec1f510e.svg";
export { ForwardRef as ReactComponent };